<template lang="html">
  <div class="editor audio" style="position: absolute;top: 0;left: 0;bottom: 0;right: 0;overflow: hidden;">
    <div style="display: table;width: 100%;height: 100%;">
      <div style="display: table-cell;vertical-align: middle;text-align: center;">
        <audio controls ref="audio"></audio>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['fileData'],
  mounted: function () {
    this.$refs.audio.src = this.fileData.data;
  },
  beforeUnmount: function () {
    console.log('Destroy');
  }
}
</script>
